export default function TermsOfUseContent() {
  return (
    <div className="p-3 flex flex-col space-y-3 whitespace-pre-wrap">
      <div className="font-bold underline text-center">
        REGULAMIN UŻYWANIA APLIKACJI „INVENIO HR” WRAZ Z POLITYKĄ PRYWATNOŚCI
      </div>
      <div className="font-bold">§ 1 - Definicje</div>
      <div className="text-justify">
        Ilekroć w umowie używane są poniższe określenia, mają one następujące
        znaczenie:
        <ol>
          <li>
            Administrator - Invenio QD Sp. z o.o. z siedzibą w Tychach przy ul.
            Fabrycznej 2, wpisana do Rejestru Przedsiębiorców Krajowego Rejestru
            Sądowego pod numerem 0000353362, posiadającą NIP 646-288-54-50,
            e-mail: tychy@invenio.pl,
          </li>
          <li>
            Aplikacja - aplikacja „INVENIO HR”, platforma teleinformatyczna
            umożliwiająca zarządzanie procesami HR, dostępna za pośrednictwem
            sieci Internet (typu „Software as a Service”), udostępniona
            pracownikom i zleceniobiorcom (współpracownikom) Administratora oraz
            pracownikom i zleceniobiorcom (współpracownikom) Spółek
            Zatrudniających,
          </li>
          <li>
            Spółka Zatrudniająca - podmiot korzystający z Aplikacji należący do
            grupy INVENIO: .: Invenio sp. z o.o., Invenio QD sp. z o.o., Quality
            and Human Services sp. z o.o. i ipsupport sp. z o.o.,
          </li>
          <li>
            Użytkownik - osoba fizyczna uprawniona do korzystania z Aplikacji, w
            szczególności:
            <ol type="a">
              <li>pracownik,</li>
              <li>zleceniobiorca (inny współpracownik),</li>
              <li>przedstawiciel Spółki Zatrudniającej;</li>
            </ol>
          </li>
          <li>Konto - indywidualny dostęp Użytkownika do Aplikacji,</li>
          <li>
            Dane osobowe - informacje o zidentyfikowanej lub możliwej do
            zidentyfikowania osobie fizycznej,
          </li>
          <li>
            Dane operacyjne - dane generowane w toku korzystania z Aplikacji, w
            tym logi systemowe,
          </li>
          <li>
            Umowa - umowa o świadczenie usług drogą elektroniczną zawarta
            poprzez akceptację Regulaminu,
          </li>
          <li>
            Regulamin - niniejszy dokument określający zasady korzystania z
            Aplikacji,
          </li>
        </ol>
      </div>
      <div className="font-bold">§ 2 - Postanowienia ogólne</div>
      <div className="text-justify">
        <ol>
          <li>
            Administrator świadczy usługi drogą elektroniczną polegające na
            udostępnieniu Aplikacji pracownikom i zleceniobiorcom
            (współpracownikom) Administratora i pracownikom i zleceniobiorcom
            (współpracownikom) Spółek Zatrudniających.
          </li>
          <li>
            Aplikacja wspiera procesy: zarządzania personelem, ewidencji i
            rozliczania czasu pracy (współpracy), planowania pracy i
            dyspozycyjności i komunikacji organizacyjnej.
          </li>
          <li>
            Aplikacja stanowi narzędzie pomocnicze i nie zastępuje dokumentacji
            wymaganej przepisami prawa. W przypadku jakichkolwiek rozbieżności -
            pierwszeństwo mają informacje wynikające z dokumentacji wymaganej
            przepisami prawa (dokumentacja pracownicza, dokumenty rozliczeniowe
            etc.)
          </li>
          <li>
            Aplikacja jest bezpłatna, można w każdym momencie zrezygnować z jej
            używania, z faktem jej uruchomienia nie łączą się żadne formalności
            - poza wyrażeniem zgody na wykorzystanie podanego adresu e-mail (w
            celu korzystania z aplikacji konieczne jest przypisanie adresu
            e-mail do konta użytkownika).
          </li>
          <li>
            Regulamin zostaje nieodpłatnie udostępniony użytkownikowi przed
            zawarciem umowy (aktywacji Konta) za pomocą korespondencji
            elektronicznej, co umożliwia jego umożliwia pozyskanie, odtwarzanie
            i utrwalanie treści regulaminu za pomocą systemu
            teleinformatycznego, którym posługuje się Użytkownik.
          </li>
          <li>
            Użytkownik zobowiązany jest do:
            <ol>
              <li>korzystania z Aplikacji zgodnie z prawem i Regulaminem,</li>
              <li>zachowania poufności danych logowania,</li>
              <li>ochrony dostępu do Konta.</li>
            </ol>
          </li>
          <li>
            Zabrania się Użytkownikowi:
            <ol>
              <li>dostarczania treści o charakterze bezprawnym,</li>
              <li>udostępniania Konta osobom trzecim,</li>
              <li>ingerencji w system Aplikacji,</li>
              <li>podejmowania działań naruszających bezpieczeństwo.</li>
            </ol>
          </li>
          <li>
            Administrator nie ponosi odpowiedzialności za:
            <ol>
              <li>przerwy techniczne,</li>
              <li>działania osób trzecich,</li>
              <li>nieprawidłowe dane wprowadzone przez Użytkownika.</li>
            </ol>
          </li>
          <li>
            Wszelkie reklamacje, zgłoszenia nieprawidłowości powinny być
            kierowane na adres e-mail Administratora: tychy@invenio.pl.
          </li>
        </ol>
      </div>
      <div className="font-bold">
        § 3 - Zawarcie umowy i dostęp do Aplikacji
      </div>
      <div className="text-justify">
        <ol>
          <li>Umowa zostaje zawarta z chwilą aktywacji Konta.</li>
          <li>
            Dostęp do Aplikacji przyznawany jest na zasadzie indywidualnych
            Kont, które w zależności od statusu użytkownika mają dostęp do
            różnych funkcjonalności („Konto Pracownik” i „Konto
            Zleceniobiorca”).
          </li>
          <li>
            Podany przez użytkownika adres e-mail jest wykorzystywany do celów:
            logowania do Aplikacji, komunikacji związanej z dostępem do systemu
            (np. reset hasła, powiadomienia systemowe), otrzymania linku
            aktywacyjnego oraz instrukcji pierwszego logowania. Przy pierwszym
            logowaniu wymagane będzie potwierdzenie tożsamości (np. numerem
            PESEL) oraz ustawienie hasła.
          </li>
          <li>
            Do skutecznego zawarcia umowy niezbędne jest urządzenie
            umożliwiające przeglądanie stron internetowych oraz komunikacji za
            pośrednictwem poczty elektronicznej, a także klawiatura lub inne
            urządzenie umożliwiające poprawne wypełnienie formularzy
            elektronicznych lub napisanie wiadomości poczty internetowej.
          </li>
          <li>
            Pozostałe wymagania techniczne to:
            <ol>
              <li>połączenie z siecią Internet,</li>
              <li>
                korzystanie z przeglądarki internetowej z obsługą JavaScript,
              </li>
              <li>akceptacja plików "cookies" w niezbędnym zakresie,</li>
              <li>posiadanie adresu poczty elektronicznej.</li>
            </ol>
          </li>
          <li>
            Administrator posługuje się tzw. plikami „cookies”, tj. informacjami
            zapisywanymi przez serwer Administratora na urządzeniu Użytkownika,
            które serwer Administratora może odczytać przy każdorazowym
            połączeniu się z urządzeniem. Stosowanie plików cookies ma na celu
            poprawne działanie Aplikacji na telekomunikacyjnych urządzeniach
            końcowych użytkowników; mechanizm ten nie powoduje zmian
            konfiguracyjnych w urządzeniach użytkowników ani w oprogramowaniu
            zainstalowanym na tych urządzeniach. Użytkownik ma możliwość
            określenia warunków korzystania z plików cookies za pomocą ustawień
            przeglądarki internetowej. W szczególności, każdy Użytkownik może
            wyłączyć mechanizm cookies w przeglądarce internetowej swojego
            telekomunikacyjnego urządzenia końcowego, przy czym wyłączenie
            mechanizmu może jednak spowodować utrudnienia lub uniemożliwić
            korzystania z Aplikacji.
          </li>
          <li>
            Administrator podejmuje działania w celu zapewnienia wysokiej
            dostępności Aplikacji. Administrator może: przeprowadzać przerwy
            serwisowe, wdrażać aktualizacje, ograniczać dostęp w sytuacjach
            awaryjnych.
          </li>
          <li>
            Administrator ma w każdym momencie prawo: odmowy dostępu,
            zawieszenia Konta, ograniczenia jego funkcjonalności.
          </li>
        </ol>
      </div>
      <div className="font-bold">§ 4 - Funkcjonalność Aplikacji</div>
      <div className="text-justify">
        Zakres dostępnych funkcjonalności zależy od: roli Użytkownika i
        konfiguracji. Aplikacja umożliwia w szczególności:
        <ol>
          <li>ewidencję czasu pracy (Konto Pracownika),</li>
          <li>zarządzanie grafikami (Konto Zleceniobiorcy)</li>
          <li>obsługę urlopów i nieobecności (Konto Pracownika),</li>
          <li>zgłaszanie dyspozycyjności (Konto Zleceniobiorcy),</li>
          <li>komunikację wewnętrzną (Konto Pracownika i Zleceniobiorcy)</li>
        </ol>
      </div>
      <div className="font-bold">§ 5 - Dane osobowe</div>
      <div className="text-justify">
        <ol>
          <li>
            Administrator - InvenioQD sp. z o.o. (43-100), ul. Fabryczna 2,
            wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego pod
            numerem 0000465121 oraz legitymująca się numerem NIP 6462930802;
            e-mail: tychy@invenio.pl - jest administratorem danych osobowych w
            zakresie podanego adresu e-mail,
          </li>
          <li>
            Celem przetwarzania danych jest prawidłowe działanie Aplikacji, w
            tym zapewnienie możliwości logowania do niej, komunikacji związanej
            z dostępem do systemu (np. reset hasła, powiadomienia systemowe),
            otrzymania linku aktywacyjnego oraz instrukcji pierwszego logowania.
          </li>
          <li>
            3. Przetwarzanie danych osobowych następuje w oparciu o zgodę osoby
            korzystającej z aplikacji. Przekazanie wypełnionego formularza
            „ZGODA NA PRZETWARZANIE ADRESU E-MAIL” lub wyrażenie takiej zgody
            przy logowaniu się do Aplikacji stanowi jednocześnie{" "}
            <u>wyrażenie zgody</u> na przetwarzanie danych osobowych przez
            InvenioQD w powyższym zakresie. Zgoda może być odwołana w każdym
            czasie, przy czym odwołanie zgody nie ma wpływu na zgodność z prawem
            przetwarzania do czasu odwołania. Odwołanie zgody będzie się wiązać
            z brakiem możliwości korzystania z aplikacji.
          </li>
          <li>
            Użytkownik może zgłosić sprzeciw wobec przetwarzania jego danych
            osobowych w każdy czasie.
          </li>
          <li>
            Do kategorii odbiorców danych osobowych Użytkowników należeć mogą
            podmioty zajmujące się obsługa informatyczną InvenioQD.
          </li>
          <li>
            Dane osobowe zgromadzone w związku z Aplikacją mogą być
            przechowywane przez InvenioQD przez okres, w jakim dana osoba
            korzysta z Aplikacji, przy czym nie dłużej niż do dnia zakończenia
            okresu zatrudnienia/współpracy/innego stosunku prawnego związanego
            ze świadczeniem usług/pracy na rzecz InvenioQD.
          </li>
          <li>
            InvenioQD nie przewiduje automatycznego przetwarzania danych
            osobowych, w tym profilowania.
          </li>
          <li>
            Użytkownicy mają prawo żądania sprostowania, usunięcia lub
            ograniczenia przetwarzania swoich danych osobowych, a nadto
            przenoszenia danych osobowych oraz wniesienia sprzeciwu wobec ich
            przetwarzania oraz prawo do wniesienia skargi do organu nadzorczego,
            którym to jest Prezes Urzędu Ochrony Danych Osobowych (ul. Stawki 2,
            00-193 Warszawa).
          </li>
          <li>
            Administratorem danych osobowych użytkowników w pozostałym zakresie
            jest Spółka Zatrudniająca, z którą Użytkownika łączy umowa o pracę /
            zlecenie / świadczenie usług. Administrator działa jako podmiot
            przetwarzający dane osobowe. Przetwarzanie odbywa się na podstawie
            umowy powierzenia danych.
          </li>
          <li>
            Celem przetwarzania danych osobowych to realizacja umowy,
            zapewnienie działania Aplikacji, zapewnienie bezpieczeństwa IT,
            audyt i compliance.
          </li>
        </ol>
      </div>
      <div className="font-bold">§ 6 - Zakończenie świadczenia usług</div>
      <div className="text-justify">
        Umowa (dostęp do Aplikacji) wygasa z chwilą usunięcia Konta - przez
        Użytkownika lub przez Administratora lub Spółki Zatrudniające (w
        przypadku ustania podstawy prawnej zatrudnienia lub współpracy).
      </div>
      <div className="font-bold">§ 7 - Postanowienia końcowe</div>
      <div className="text-justify">
        <ol>
          <li>
            Prawem właściwym dla Umowy jest prawo polskie, z wyłączeniem norm
            kolizyjnych; wszelkie spory związane z usługami Aplikacji będą
            rozstrzygane przez właściwe polskie sądy powszechne.
          </li>
          <li>
            W sprawach nieuregulowanych w Regulaminie zastosowanie mają przepisy
            ustawy o świadczeniu usług drogą elektroniczną, ustawy o prawie
            autorskim i prawach pokrewnych, ustawy o ochronie danych osobowych,
            kodeksu cywilnego i inne, bezwzględnie obowiązujące przepisy prawa.
          </li>
          <li>
            Administrator ma możliwość dokonania zmian w Regulaminie w każdym
            czasie.
          </li>
        </ol>
      </div>
      <div className="text-justify">Tychy, dnia 30 kwietnia 2026 roku</div>
    </div>
  );
}
